import { createApp } from 'vue'
import StafetHeader from './StafetHeader'

const el = '.kb-component--stafet-flow-title'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetHeaderDOM) => {
            const component = createApp(StafetHeader).use(Store)
            component.mount(StafetHeaderDOM)
        })
    }
}
